import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const TruckIconCyan: FC<IconProps> = ({ width = 42, height = 30, ...rest }) => (
  <Icon type="TruckCyan" width={width} height={height} alt="TruckIconCyan" {...rest} />
)
